'use client';

import { c as _c } from "react/compiler-runtime";
import type { PortalProps } from '@common/components';
import { Portal, Slot } from '@common/components';
import { cn } from '@core/utils';
import { useEffect } from 'react';
import { SELECTOR } from '@/constants';
interface BottomNavPortalProps extends Pick<PortalProps, 'onLoaded' | 'children'> {
  hasShadow?: boolean;
  contentClassName?: string;
  wrapperClassName?: string;
}
export const BottomNavPortal = t0 => {
  const $ = _c(19);
  const {
    children,
    onLoaded,
    hasShadow: t1,
    contentClassName,
    wrapperClassName
  } = t0;
  const hasShadow = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useEffect(_temp, t2);
  let t3;
  if ($[1] !== wrapperClassName) {
    t3 = cn("fixed inset-x-0 bottom-0 z-20 flex justify-center bg-Gray-white pb-[var(--safe-area-bottom,0px)]", wrapperClassName);
    $[1] = wrapperClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== contentClassName) {
    t4 = cn("relative w-full max-w-screen-xl xl:max-w-[600px]", contentClassName);
    $[3] = contentClassName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== hasShadow) {
    t5 = cn({
      "shadow-large": hasShadow
    });
    $[5] = hasShadow;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t5) {
    t6 = <Slot className={t5}>{children}</Slot>;
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onLoaded || $[17] !== t8) {
    t9 = <Portal renderTo={_temp2} onLoaded={onLoaded}>{t8}</Portal>;
    $[16] = onLoaded;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
function _temp() {
  const root = document.documentElement;
  root.style.setProperty("--bottom-nav-portal-height", "calc(88px + var(--safe-area-bottom, 0px))");
  return () => {
    root.style.removeProperty("--bottom-nav-portal-height");
  };
}
function _temp2() {
  return document.getElementById(SELECTOR.MAIN_WRAPPER);
}